import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    position?: number;
};
export const schemaLoanRequestResolver_GetDistributedCount = z.number();

export type SchemaLoanRequestResolver_GetDistributedCount = z.infer<
    typeof schemaLoanRequestResolver_GetDistributedCount
>;

export type LoanRequestResolver_GetDistributedCount = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetDistributedCount
>;
